// A clickable element that is not a native button (an icon, a label, a span in a row) answers the
// keyboard the way it answers a click: it is reached with Tab, reads as a button, and is pressed
// with Enter or Space. With no handler it is left inert -- no role, out of the tab order.
export const pressable = (handler, { disabled = false } = {}) => {
  if (!handler) return { onClick: null }

  return {
    role: 'button',
    tabIndex: disabled ? -1 : 0,
    'aria-disabled': disabled || undefined,
    onClick: disabled ? null : handler,
    onKeyDown: disabled
      ? null
      : event => {
          if ('Enter' !== event.key && ' ' !== event.key) return
          event.preventDefault()
          handler(event)
        }
  }
}
